import { Button } from "@material-ui/core"
import { useState } from "react"
import BackDrop from "../../../global/BackDrop"
import { useSelector, useDispatch } from "react-redux"
import { anularVerificarCuentaAction, selectClienteTarget } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import { usePermiso } from "../../../hooks/usePermiso"
import { catRoles } from "./../../../constant/catRoles"
const BAnularVerificacion = () => {
    const [permitido] = usePermiso({ location: "FK_AdministrarClientes_Anular", initialValue: false })
    const { profile } = useSelector(store => store.logeo)
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleVerificar = () => {
        DialogMessage.fire({
            title: `Verficar cuenta`,
            text: `¿Esta seguro de anular la verificación de esta referencia?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(anularVerificarCuentaAction({ IdCuenta: cliente?.Movimiento?.Cuenta?.Id_Cuenta })).then(Response => {
                    if (Response?.status && Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    setLoad(false)
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    if (verificado)
        if (profile.Rol?.Id === catRoles.ADMINISTRADOR || permitido)
            return (
                <div>
                    <Button onClick={handleVerificar} variant="contained" color="primary">Anular verificación</Button>
                    <BackDrop open={load} />
                </div>
            )
    return (
        <div>
        </div>
    )
}
export default BAnularVerificacion